import { createSelector } from 'reselect'
import {
  networkGroup,
} from '@nocode-works/template/store/selectors/utils'

import userSelectors from './user'
import subscriptionUtils from 'utils/subscription'

import {
  DEFAULT_CURRENCY,
  CURRENCIES,
} from 'settings'

const websites = state => state.website.websites
const customer = state => state.stripe.customer
const products = state => state.stripe.products
const card = state => state.stripe.card
const invoices = state => state.stripe.invoices
const cancelledSubscriptions = state => state.stripe.cancelledSubscriptions
const changePlanWebsite = state => state.stripe.changePlanWebsite
const changePlanInfo = state => state.stripe.changePlanInfo
const cancelSubscriptionWindowOpen = state => state.stripe.cancelSubscriptionWindowOpen
const reactivateSubscriptionWindowOpen = state => state.stripe.reactivateSubscriptionWindowOpen
const cancelledSubscriptionInvoices = state => state.stripe.cancelledSubscriptionInvoices
const viewCancelledSubscription = state => state.stripe.viewCancelledSubscription

const subscription = createSelector(
  customer,
  customer => {
    if(!customer) return null
    return customer.subscriptions.data[0]
  }
)

const subscriptionCurrency = createSelector(
  subscription,
  subscription => {
    if(!subscription) return null
    if(subscription.items.data.length <= 0) return null
    return subscription.items.data[0].price.currency
  }
)

const currency = createSelector(
  userSelectors.currencyId,
  subscriptionCurrency,
  (user, subscription) => {
    const currencyName = subscription || user || DEFAULT_CURRENCY
    return CURRENCIES.find(c => c.id == currencyName)
  }
)

const productList = createSelector(
  currency,
  products,
  (currency, products) => {
    if(!currency) return []
    return products.map(product => {
      return Object.assign({}, product, {
        price: product.prices.find(price => price.currency == currency.id)
      })
    })
  }
)

const allPrices = createSelector(
  products,
  products => {
    return products.reduce((all, product) => {
      return all.concat(product.prices)
    }, [])
  }
)

const priceMap = createSelector(
  allPrices,
  prices => prices.reduce((all, price) => {
    all[price.id] = price
    return all
  }, {})
)

const changePlanInfoSummary = createSelector(
  changePlanInfo,
  products,
  websites,
  priceMap,
  (changePlanInfo, products, websites, priceMap) => {
    if(!changePlanInfo) return null
    const {
      website,
      product,
      price,
      result,
    } = changePlanInfo
    const websiteData = websites.find(w => w.id == website)
    if(!websiteData) return null
    const productData = products.find(p => p.id == product)
    if(!productData) return null
    const priceData = productData.prices.find(p => p.id == price)
    if(!priceData) return null

    const newInvoiceLineItems = result.lineItems.map(lineItem => {
      return Object.assign({}, lineItem, {
        price: priceMap[lineItem.price],
      })
    })

    const lineItemInfo = subscriptionUtils.getLineItemsInfo(newInvoiceLineItems)

    return {
      website: websiteData,
      product: productData,
      price: priceData,
      cost: result.cost,
      nextInvoice: result.invoice.amount_due,
      subsequentInvoices: lineItemInfo.total,
      lineItems: newInvoiceLineItems,
    }
  }
)

const selectors = {
  subscription,
  products,
  productList,
  card,
  invoices,
  cancelledSubscriptions,
  currency,
  subscriptionCurrency,
  changePlanWebsite,
  changePlanInfo,
  cancelSubscriptionWindowOpen,
  reactivateSubscriptionWindowOpen,
  changePlanInfoSummary,
  cancelledSubscriptionInvoices,
  viewCancelledSubscription,
  ...networkGroup('stripe', [
    'loadProducts',
    'loadCustomer',
    'loadCard',
    'loadInvoices',
    'changeWebsitePlan',
    'changeCard',
    'cancelSubscription',
  ])
}

export default selectors
